import { RootState } from '@/store'

export default function selectUserHasPendingPlan(state: RootState) {
  return state.user.user?.profile?.is_plan_pending
}
